import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  city = '';
  weatherData: any = null;

  constructor(private http: HttpClient) {}

  fetchWeather() {
    console.log("fetchweather function called")
    console.log("this city trim quals", this.city.trim())
    // Check if the city input is empty and alert the user
      if (!this.city.trim()) {
        alert('Please enter at least one letter to submit the city name.');
        return;
      }
    const url = `https://city-weather-node-express-be-tulaneadam21.vercel.app/weather?city=${this.city}`;
    this.http.get(url).subscribe(
      data => {
        this.weatherData = data;
      },
      error => {
        console.error('Error:', error);
      }
    );
  }

  convertToFahrenheit(celsius: number): string {
    return celsius ? ((celsius * 9) / 5 + 32).toFixed(2) : '';
  }

  get formattedCity(): string {
    return this.city
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
